export default __webpack_public_path__ + "static/media/emergency-mapping.5912095d.jpg";